import { useSelector } from "react-redux";
import { hasAdminAccess } from "../../reducers/authSlice";
import CardButton from "../usercontrols/CardButton";

const HomePage = () => {
  const isAdmin = useSelector(hasAdminAccess);

  return (
    <div className="cards-grp">
      <CardButton
        dataTestid="MyAccount"
        route="/myAccount"
        icon="fi-rr-user"
        title="My Account"
        tooltip="View and manage your account"
      />
      <CardButton
        dataTestid="CompanyAdministrators"
        route="/companyAdmin"
        icon="fi-bs-hotel"
        title="Company Administrators"
        tooltip="View a list of administrators for your company"
      />
      <CardButton
        dataTestid="MyServices"
        route="/myServices"
        icon="fi-rr-browser"
        title="My Services"
        tooltip="View services active for your account"
      />
      {isAdmin ? (
        <CardButton
          dataTestid="UserManagement"
          route="/userManagement"
          icon="fi-ss-users"
          title="User Management"
          tooltip="Create, Edit, Deactivate users in your company"
        />
      ) : null}
    </div>
  );
};

export default HomePage;
